export const weightvariants = {
  weights: [100, 250, 500, 1, 2, 3, 5, 10, 15, 20, 25, 30],
  factors: [0.1, 0.25, 0.5, 1, 2, 3, 5, 10, 15, 20, 25, 30],
};
